import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdvisorOpeningHours } from '../model';

/**
 * Weekly opening hours of the logged in advisor. Clients writing outside of them get the reply text
 * once per closed period as automatic chat reply.
 */
@Injectable({
  providedIn: 'root',
})
export class AdvisorOpeningHoursService {
  private readonly baseUrl = `${environment.apiEndpoint}/account/advisor/self/opening-hours`;

  constructor(private http: HttpClient) {}

  public getOpeningHours(): Observable<AdvisorOpeningHours> {
    return this.http.get<AdvisorOpeningHours>(this.baseUrl);
  }

  /** Replaces the opening hours; an empty slot list removes them. */
  public updateOpeningHours(openingHours: AdvisorOpeningHours): Observable<AdvisorOpeningHours> {
    return this.http.put<AdvisorOpeningHours>(this.baseUrl, openingHours);
  }
}
